// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"842":"4c8f6c51f93a0f12","1196":"f126a06903abdda3","1885":"242c696350503d02","2248":"c92d3b743144863b","5650":"68dc23d7298ec587","6771":"227cf772a3935760","7743":"2cdc92b40aa474bd"}[chunkId] + ".css";
};